import { Sparkles } from "lucide-react";

const items = [
  "First 100 users get ₹100 cashback on first ride",
  "Going the same way? Ride together",
  "Switch roles in under 10 minutes",
  "Launching 1st October 2026 — Join the waitlist",
  "Save up to 60% on daily commutes",
];

const Item = ({ text }) => (
  <div className="flex items-center gap-3 px-6 shrink-0">
    <Sparkles className="w-3.5 h-3.5 text-white" strokeWidth={2.5} />
    <span className="font-display text-[13px] uppercase tracking-[0.2em] text-white font-semibold whitespace-nowrap">
      {text}
    </span>
  </div>
);

export default function CashbackMarquee() {
  return (
    <div
      data-testid="cashback-marquee"
      className="relative w-full overflow-hidden border-b border-[#5FA836]/40 bg-[#24303F] py-2.5 z-50"
    >
      <div className="flex marquee-track" style={{ width: "max-content" }}>
        {[...items, ...items, ...items].map((t, i) => (
          <Item text={t} key={i} />
        ))}
      </div>
    </div>
  );
}
